import { createContext } from 'react'
import { ICurrentUser } from '../Interfaces/user.interface'

const UserContext = createContext<ICurrentUser | null>(null)

export default UserContext
